import styled from 'styled-components';
import { spacings } from '../../../tokens/spacings';
import { theme } from '../../../tokens/theme';

export const EmptyPage = styled.div`
  background-color: ${theme.light.ui.background.default};
  display: grid;
  place-items: center;
  height: 100%;

  .loading {
    display: flex;
    align-items: center;
    flex-direction: row;
    column-gap: ${spacings.MEDIUM};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ContentWrapper = styled.main`
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
`;
